<template>
  <div class="flex flex-col gap-6 proxima_nova text_color">
    <div class="text-2xl font-semibold primary_color">Support</div>

    <CustomTabs
      v-model="activeTab"
      :tabs="tabs"
      content-padding="pt-6"
      extra-header-styles=""
      tab-header-class=""
    >
      <template #tab_content-0>
        <div class="support-email-tab-wrapper">
          <SupportEmailSettings source="support" />
        </div>
      </template>

      <template #tab_content-1>
        <SupportWhatsAppSettings />
      </template>

      <template #tab_content-2>
        <SupportAIAgentSettings />
      </template>
    </CustomTabs>
  </div>
</template>

<script setup>
import { ref } from "vue";
import CustomTabs from "@/src/components/CustomTabs.vue";
import SupportEmailSettings from "@/src/views/settings/SupportEmailSettings.vue";
import SupportWhatsAppSettings from "@/src/views/settings/SupportWhatsAppSettings.vue";
import SupportAIAgentSettings from "@/src/views/settings/SupportAIAgentSettings.vue";

const tabs = [
  { title: "Email" },
  { title: "WhatsApp" },
  { title: "AI Agent" },
];

const activeTab = ref(0);
</script>

<style scoped>
/*
 * Hide the child SupportEmailSettings component's own "Support" heading
 * since this parent already renders the heading above the tab bar.
 * The combination of these three classes is unique to that heading element.
 */
.support-email-tab-wrapper :deep(.text-2xl.font-semibold.primary_color) {
  display: none;
}
</style>
